import { ErrorBoundary } from '@sentry/react';
import { Typography } from '@statsbomb/kitbag-components';
import { ReactNode, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { GeneralFallback } from '@/components/contentState/GeneralFallback';
import { MenuItemWithIcon } from '@/components/menu/MenuItemWithIcon';
import { MoreOptionsMenu } from '@/components/menu/MoreOptionsMenu/MoreOptionsMenu';

export const AsideContent = ({
  children,
  title,
  onClear,
  className,
  withOptionsMenu = true,
}: {
  children: ReactNode;
  title: string;
  onClear?: () => void;
  className?: string;
  withOptionsMenu?: boolean;
}) => {
  const { t } = useTranslation('general');

  return (
    <aside
      className={twMerge(
        'w-full md:!w-[320px] h-full bg-canvas-secondary-main pt-4 px-4 flex flex-col gap-4',
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <Typography variant="headingMedium">{title}</Typography>
        {withOptionsMenu && (
          <MoreOptionsMenu>
            <MenuItemWithIcon icon="Erase" text={t('clearAll')} onClick={onClear} />
          </MoreOptionsMenu>
        )}
      </div>
      <div className="overflow-y-auto flex-1">
        <ErrorBoundary fallback={<GeneralFallback type="error" />}>
          <Suspense fallback={<GeneralFallback type="loading" />}>{children}</Suspense>
        </ErrorBoundary>
      </div>
    </aside>
  );
};
